import React, { PropsWithChildren } from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import Tooltip from 'components/shared/Tooltip';
import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';

type Props = PropsWithChildren<{
  itemId: string;
  customStyleKey?: string;
  isActionsDisabled?: boolean;
  onEdit: () => void;
  onDelete: () => void;
}>;

function FileItem({ customStyleKey, itemId, children, isActionsDisabled, onEdit, onDelete }: Props) {
  return (
    <div key={itemId} className={cx(styles.sheetsItem, { [`${customStyleKey}-list-item`]: customStyleKey })}>
      <Text accent className={cx(styles.sheetName, { [`${customStyleKey}-list-item-name`]: customStyleKey })}>
        {children}
      </Text>

      <div
        className={cx(styles.roomActions, isActionsDisabled && styles.roomActionsDisabled, {
          [`${customStyleKey}-list-item-actions`]: customStyleKey,
        })}
        data-tip
        data-for={`file_list__${itemId}`}
      >
        <Text
          accent
          className={cx(styles.edit, { [`${customStyleKey}-list-item-edit`]: customStyleKey })}
          onClick={onEdit}
        >
          Edit
        </Text>

        <button
          type="button"
          className={cx(styles.sheetBtn, { [`${customStyleKey}-list-item-delete-btn`]: customStyleKey })}
          onClick={onDelete}
        >
          <Icon
            component={Trash2}
            className={cx(styles.icon, { [`${customStyleKey}-list-item-delete-icon`]: customStyleKey })}
          />
        </button>
      </div>

      <Tooltip id={`file_list__${itemId}`} disable={!isActionsDisabled}>
        Access to personal data is restricted
      </Tooltip>
    </div>
  );
}

export default FileItem;
